function getBeagleLanguage(langToCheck) {

    langToCheck = langToCheck.substr(0, 2).toLowerCase();

    switch (langToCheck) {
        case undefined:
            return 'en';
        case 'es':
            return 'es';
        case 'fr':
            return 'fr';
        case 'pt':
            return 'pt';
        case 'ru':
            return 'ru';
        case 'zh':
            return 'zh';
        default:
            return 'en';
    }

}


export function validateLanguagePreferenceKeyword(pref) {

    //When there's no existing user preference, use the native platform.
    if (pref === undefined) {
        return getBeagleLanguage(navigator.language);
    } else {
        return getBeagleLanguage(pref);
    }

}


export function validateMathPreferenceKeyword(pref) {

    if (pref === undefined) {
        return 'm';
    }

    switch (pref) {
        case 'i':
            return 'i';
        case 'm':
            return 'm';
        default:
            return 'm';
    }
}
